module.exports = __webpack_public_path__ + "shop.7de49f4b.png";